import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { PaymentsScreen } from "../screens/PaymentsScreen";
import { paymentsSearch } from "../screens/purchaseSearch";

export const Route = createFileRoute("/prototype/c/$companyId/purchases/payments/")({
  validateSearch: (search) => paymentsSearch.parse(search),
  component: SupplierPayments,
});

function SupplierPayments() {
  const { companyId } = Route.useParams();
  const { tab } = Route.useSearch();
  return (
    <PaymentsScreen companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY} tab={tab} />
  );
}
